import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import ApplicationUpdater from './state/application/updater'
import ListsUpdater from './state/lists/updater'
import MulticallUpdater from './state/multicall/updater'
import TransactionUpdater from './state/transactions/updater'
import ToastListener from './components/ToastListener'
import Providers from './Providers'
import './i18n'
import './utils/firebase'

if ('ethereum' in window) {
  ;(window.ethereum as any).autoRefreshOnNetworkChange = false
}

window.addEventListener('error', () => {
  localStorage?.removeItem('redux_localstorage_simple_lists')
})

// Dev only: hide error overlays (webpack overlay or any on-screen RPC error box)
if (process.env.NODE_ENV === 'development') {
  const hideErrorOverlays = () => {
    document.querySelectorAll('iframe, [data-reactroot] > div').forEach((node) => {
      const el = node as HTMLElement & { contentDocument?: Document }
      try {
        const doc = el.contentDocument || el.ownerDocument
        const text = (doc?.body?.innerText ?? el.innerText ?? '') + (el.textContent ?? '')
        if (
          text.includes('Invalid JSON RPC') ||
          text.includes('JSON RPC response') ||
          text.includes('InvalidResponse')
        ) {
          el.style.setProperty('display', 'none', 'important')
        }
      } catch {
        // ignore
      }
    })
    document.querySelectorAll('body > div').forEach((div) => {
      const el = div as HTMLElement
      const text = el.innerText ?? el.textContent ?? ''
      if (
        (text.includes('Invalid JSON RPC') || text.includes('InvalidResponse')) &&
        (el.style?.position === 'fixed' || getComputedStyle(el).position === 'fixed' || el.style?.zIndex)
      ) {
        el.style.setProperty('display', 'none', 'important')
      }
    })
  }
  setInterval(hideErrorOverlays, 500)
}

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <>
        <ListsUpdater />
        <ApplicationUpdater />
        <TransactionUpdater />
        <MulticallUpdater />
        <ToastListener />
      </>
      <App />
    </Providers>
  </React.StrictMode>,
  document.getElementById('root'),
)
